<template>
  <div>
    <!-- Toolbar -->
    <div class="has-background-white rounded-lg py-md px-lg mb-xxs">
      <div class="columns is-vcentered">
        <div class="column">
          <div class="px-sm has-text-grey-light">
            <em v-if="context.isSupplier()" class="is-size-7">Let {{ connection.retailer.name }} know when your warehouse is closed or operating on a holiday.</em>
            <em v-else class="is-size-7">Holidays and warehouse closures provided by {{ connection.brand.name }}.</em>
          </div>
        </div>
        <div v-if="context.isSupplier()" class="column is-narrow">
          <div class="px-sm">
            <b-button
              type="is-primary"
              outlined
              expanded
              @click.prevent="showEditHolidayScheduleModal = true"
            >{{ holidays.length > 0 ? 'Edit' : 'Add' }} Holiday Schedule</b-button>
          </div>
        </div>
      </div>
    </div>
    <!-- Holiday Schedule -->
    <div class="mb-lg">
      <div class="has-background-white rounded-lg pa-lg">
        <div v-if="holidays.length > 0">
          <div class="pb-sm has-border-b has-border-lg">
            <div class="columns is-vcentered">
              <div class="column">
                <p class="has-text-primary has-text-weight-bold">Holiday Schedule</p>
              </div>
              <div class="column is-narrow">
                <p class="has-text-grey is-size-7">{{ schedule.year }}</p>
              </div>
            </div>
          </div>
          <table class="table is-fullwidth is-striped is-narrow is-size-7 is-vcentered">
            <tbody>
              <tr v-for="holiday in holidays" :key="holiday.date + holiday.name" :class="{ 'has-text-grey-light': holiday.isPast }">
                <td width="30%">
                  {{ $dates(holiday.date).format('MM/DD/YYYY') }}
                  <span class="has-text-grey">({{ $dates(holiday.date).format('dddd') }})</span>
                </td>
                <th :class="{ 'has-text-grey-light': holiday.isPast }">{{ holiday.name }}</th>
                <td class="has-text-right">
                  <b-tag rounded :type="holiday.operating ? 'is-success' : 'is-warning'">{{ holiday.operating ? 'Operating' : 'Closed' }}</b-tag>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- No Holiday Schedule -->
        <div v-else class="has-text-centered py-xxl">
          <p v-if="context.isSupplier()" class="has-text-grey-light">
            You haven't added a holiday schedule for this connection yet.
          </p>
          <p v-else class="has-text-grey-light">
            {{ connection.brand.name }} hasn't provided a holiday schedule yet.
          </p>
        </div>
      </div>
    </div>
    <!-- Edit Holiday Schedule Modal -->
    <b-modal
      v-if="context.isSupplier()"
      has-modal-card
      scroll="keep"
      :active.sync="showEditHolidayScheduleModal"
      :can-cancel="['escape']"
    ><EditHolidayScheduleModal :connection="connection" :schedule="schedule" @saved:connection="$emit('updated')" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditHolidayScheduleModal from '../components/Holidays/EditHolidayScheduleModal'

export default {
  components: {
    EditHolidayScheduleModal
  },
  computed: {
    ...mapGetters(['context']),
    schedule () {
      const metadata = this.connection.metadata && this.connection.metadata['Holiday Schedule']
      if (!metadata || !metadata.values.length) return null
      try {
        return JSON.parse(metadata.values[0].value)
      } catch (e) {
        return null
      }
    },
    holidays () {
      if (!this.schedule || !Array.isArray(this.schedule.holidays)) return []
      const today = this.$dates().format('YYYY-MM-DD')
      return [...this.schedule.holidays]
        .sort((a, b) => a.date.localeCompare(b.date))
        .map(holiday => ({ ...holiday, isPast: holiday.date < today }))
    }
  },
  data () {
    return {
      showEditHolidayScheduleModal: false
    }
  },
  props: ['connection', 'loading']
}
</script>
